module.exports = __webpack_public_path__ + "img/features-bg_14.36f48282.png";